<div class="button button-text button-text__right [.epg__player:not(.live)_&]:hidden">{{ svg "fast-forward" 44 "icon mr-12"}}<span><div class="label label-live">{{ T "stream.play_live" }}</div></span></div>
